export const fmtPrice = (n) => (n == null ? "—" : `₪${Number(n).toLocaleString("en-US")}`);
export const fmtNum = (n) => (n == null || n === "" ? "—" : Number(n).toLocaleString("en-US"));
export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";
export const vTitle = (v, lang) => v?.[`title_${lang}`] || v?.title_he || v?.title_ar || `${v?.brand || ""} ${v?.model || ""}`.trim();
export const vDesc = (v, lang) => v?.[`desc_${lang}`] || v?.desc_he || v?.desc_ar || "";
const COLORS = [["לבן", "أبيض"], ["שחור", "أسود"], ["אפור", "رمادي"], ["כסוף", "فضي"], ["כחול", "أزرق"], ["תכלת", "أزرق فاتح"], ["אדום", "أحمر"],
  ["צהוב", "أصفر"], ["ירוק", "أخضر"], ["חום", "بني"], ["בז'", "بيج"], ["כתום", "برتقالي"], ["סגול", "بنفسجي"], ["זהב", "ذهبي"], ["בורדו", "خمري"]];
export const colorL = (c, lang) => {
  const s = (c || "").trim();
  const row = COLORS.find((r) => r.includes(s));
  return row ? row[lang === "ar" ? 1 : 0] : s;
};


export const FUELS = ["petrol", "diesel", "hybrid", "plugin", "electric"];
export const GEARS = ["automatic", "manual"];
export const BODIES = ["suv", "sedan", "coupe", "convertible", "hatchback", "wagon", "pickup", "van", "other"];
export const PLATFORMS = ["facebook", "instagram", "tiktok", "telegram", "yad2"];
export const PLATFORM_LABEL = { facebook: "Facebook", instagram: "Instagram", tiktok: "TikTok", telegram: "Telegram", yad2: "Yad2" };
export const SITE = window.location.origin;
export const OFFICIAL_PHONE = "+972502917236";

export const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    ta.style.fontSize = "16px";
    ta.setAttribute("readonly", "");
    document.body.appendChild(ta);
    ta.select();
    ta.setSelectionRange(0, text.length);
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  }
};
